import type { Environment } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';

type CloudId = string;
type CloudName = string;

// MR - stands for the atlassian monorepo prefix
const isOverridingFragments = (): boolean => {
	const buildKey = globalThis.BUILD_KEY;
	return !!(buildKey && !/^(?:(?:MR)?JF-PROD-\d+|\d+\.\d+\.\d+-[0-9a-f]+)$/.test(buildKey));
};

const isOverridingSsr = (): boolean => {
	const ssrBuildKey = globalThis.SSR_BUILD_KEY;
	return !!(ssrBuildKey && !/^(?:(?:MR)?JF-PROD-\d+|\d+\.\d+\.\d+-[0-9a-f]+)$/i.test(ssrBuildKey));
};

const isVoltExplore = ({
	cloudId,
	cloudName,
}: {
	cloudId: CloudId;
	cloudName: CloudName;
}): boolean => /^(TEST--)/.test(cloudId) && /^(atl-vertigo--jira-jira-branch)/.test(cloudName);
/**
 * Selects the 'staging' environment under specific conditions, defaulting to 'dev' otherwise.
 * This decision is based on the current environment setting and the absence of specific overrides.
 */
const getStagingEnvironment = ({
	environment,
	cloudId,
	cloudName,
}: {
	cloudId: CloudId;
	cloudName: CloudName;
	environment: Environment | null;
}): string => {
	if (
		environment === 'staging' &&
		!isOverridingFragments() &&
		!isOverridingSsr() &&
		!isVoltExplore({
			cloudId,
			cloudName,
		})
	) {
		return environment;
	}
	return 'dev';
};
export default getStagingEnvironment;
